import React from 'react';

import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AxisLabel = styled(Typography)<{ textAlign?: 'left' | 'right' }>`
  font-size: 16px;
  font-weight: 400;
  text-align: ${({ textAlign }) => textAlign ?? 'right'};
`;

export const MasteryHeatMapYAxisLabels = () => (
  <>
    <Box height="32px" />
    <AxisLabel>Mon</AxisLabel>
    <AxisLabel>Tue</AxisLabel>
    <AxisLabel>Wed</AxisLabel>
    <AxisLabel>Thu</AxisLabel>
    <AxisLabel>Fri</AxisLabel>
  </>
);
